// Product Accordion JavaScript

document.addEventListener('DOMContentLoaded', function() {
  const accordionHeaders = document.querySelectorAll('.product-accordion-header');
  
  accordionHeaders.forEach(function(header) {
    header.addEventListener('click', function() {
      const item = this.parentElement;
      const isActive = item.classList.contains('active');
      
          // // 关闭所有手风琴
          // document.querySelectorAll('.product-accordion-item').forEach(function(i) {
          //   i.classList.remove('active');
          //   i.querySelector('.product-accordion-header').setAttribute('aria-expanded', 'false');
          // });
      
    
// 切换当前项的状态
if (isActive) {
  item.classList.remove('active');
  this.setAttribute('aria-expanded', 'false');
} else {
  item.classList.add('active');
  this.setAttribute('aria-expanded', 'true');
}
    });
  });
});